import React from "react";
import { Button } from "@nextui-org/react";
import { useNavigate } from "react-router-dom";
import BreadCrumbsPage from "./BreadCrumbsPage";

const ComingSoon = ({ 
  title = "Coming Soon", 
  description = "This feature is under development and will be available soon.",
  icon = "🚧",
  showBackButton = true 
}) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Page Header */}
      <div className="bg-white border-b border-slate-200 px-8 py-6 shadow-sm">
        <div className="flex items-center justify-between max-w-full">
          <div>
            <h1 className="text-2xl font-semibold text-slate-900">{title}</h1>
            <p className="text-sm text-slate-600 mt-1">Feature under development</p>
          </div>
          {showBackButton && (
            <Button
              color="primary"
              variant="ghost"
              className="text-slate-600 hover:text-slate-900"
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
          )}
        </div>
      </div>

      <BreadCrumbsPage>
        <div className="max-w-7xl mx-auto px-8 py-8">
          <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-12">
            <div className="text-center">
              <div className="text-6xl mb-6">{icon}</div>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">{title}</h2>
              <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto">
                {description}
              </p>
              <div className="bg-slate-50 rounded-lg p-6 max-w-md mx-auto">
                <p className="text-sm text-slate-500">
                  This page is part of our roadmap and will be implemented soon. 
                  Check back later for updates!
                </p>
              </div>
            </div>
          </div>
        </div>
      </BreadCrumbsPage>
    </div>
  );
};

export default ComingSoon;
